/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from "react"
import { ViewportProvider } from "./src/contexts/viewport-context"
import { ThemeProvider } from "./src/contexts/theme-context"
//import { defineCustomElements } from "./src/lib/stencil-slider/loader"

//defineCustomElements(window)
//import { WidthProvider } from "./src/contexts/width-context"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <ViewportProvider>{element}</ViewportProvider>
  </ThemeProvider>
)
